/**
 * lib/idempotency.ts
 * Generates a client-side idempotency key so a retried mutation is de-duped by
 * the adapter. Shared by every service that performs a write.
 */
export const newIdempotencyKey = (prefix: string): string =>
  `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
